import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SocialIconsComponent } from '@commons/social-icons/social-icons.component';

@NgModule({
  imports: [CommonModule],
  declarations: [SocialIconsComponent],
  exports: [SocialIconsComponent],
})
export class SocialIconsModule {}
